import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import TextField from "@mui/material/TextField";

const Water = ({ value, onChange }) => {
  const waterOptions = ["low", "medium", "high"];

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel id="water-label">Water</InputLabel>
        <Autocomplete
          id="water"
          value={value}
          onChange={(event, newValue) => {
            onChange(newValue);
          }}
          options={waterOptions}
          renderInput={(params) => <TextField {...params} label="Water" />}
        />
      </FormControl>
    </Box>
  );
};

export default Water;
